import React from 'react'
import {withStyles} from 'external/material'
import {ChatIcon, BellIcon} from '../../resources/icons'
import Icon from '../icon'

const ChatWithNotification = withStyles({
  bell: {
    position: 'relative',
    top: -26,
    left: -10 
  }
})(props => {
  const {classes}  = props
  return (
  <span className={classes.root}>
    <BellIcon className={classes.bell}/>
    <Icon name={props.name} />
  </span>)
})

export default function ChatItem ({unreadMessages}) {
  const hasUnreadMessages = unreadMessages > 0
  const Chat = hasUnreadMessages
    ? ChatWithNotification
    : Icon
  return (<Chat name="chat" />)
}
